import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const CheckCircleIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' {...props} ref={ref}>
        <path
            fill='currentColor'
            d='M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1.76 14.7-1.41-1.42L6 12.45l1.41-1.41 2.83 2.82 6.37-6.36 1.41 1.41-7.78 7.78Z'
        />
    </svg>
));
